import React, { useEffect, useState } from 'react';
import { ConfirmFlexModal, Input, ManagedFlexModal } from '@riac/design-system';
import { PhoneBookSelect } from 'src/pages/AccountPage/PhoneBook/PhoneBook.style';
import { Item } from '@react-stately/collections';
import { CancelButton, SubmitButton } from 'src/pages/AccountPage/components/AddressForm/AddressForm.style';

type CachedEditPhoneData = [] | [number, number, number];


export const showFormStatuses = ['create', 'edit'];

export const PhoneForm = ({
  phones,
  phoneAction,
  setPhoneAction,
  selectedPhone,
  setSelectedPhone,
  getPhones,
}) => {
  const [phoneNum, setPhoneNum] = useState<string>('');
  const [phoneExt, setPhoneExt] = useState<string>('');
  const [phoneTypes, setPhoneTypes] = useState([]);
  const [invalidPhoneNumber, setInvalidPhoneNumber] = useState('');
  const [reverifyConfirm, setReverifyConfirm] = useState(false);
  const [editPhoneData, setEditPhoneData] = useState<CachedEditPhoneData>([]);


  async function getPhoneTypes() {
    const typeReq = await fetch('/api/account/phone/getTypes', {
      credentials: 'include',
    });
    const typeList = await typeReq.json();
    setPhoneTypes(typeList);
  }

  async function addPhone(type, number) {
    await fetch('/api/account/phone/newPhone', {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phoneTypeID: type,
        phoneNumber: number,
      }),
    });
    setPhoneAction('done');
    getPhones();
  }

  async function updatePhone(type, number, id) {
    await fetch('/api/account/phone/updatePhone', {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phoneTypeID: type,
        phoneNumber: number,
        phoneID: id,
      }),
    });
    setPhoneAction('done');
    getPhones();
  }

  function handleSubmit() {
    const typeID = parseInt(currentPhoneType.PhoneTypeID + '');
    let num = phoneNum;
    if(num.length > 15) {
      setInvalidPhoneNumber('Number is too long.');
      return;
    }
    if(phoneExt) {
      num = num + ` Ext:${phoneExt}`;
    }
    setInvalidPhoneNumber('');
    if(num.indexOf('911') == 0) {
      setInvalidPhoneNumber('Numbers may not begin with the digits "911". Please enter a different number');
      return;
    }

    if(phoneAction === 'create') {
      addPhone(typeID, num);
    }
    if(phoneAction === 'edit') {
      // check here if already verified---warn re-verification will be needed after an edit
      const matchPhone = phones.slice().filter((phone) => phone.PhoneID == selectedPhone.phoneID);
      if(matchPhone[0] && matchPhone[0].VerifiedID == 1) {
        setEditPhoneData([typeID, num, selectedPhone.phoneID]);
        setReverifyConfirm(true);
        return;
      } else if(matchPhone[0] || matchPhone[0].VerifiedID !== 1) {
        updatePhone(typeID, num, selectedPhone.phoneID);
      }
    }
  }

  useEffect(() => {
    getPhoneTypes();
  }, []);

  useEffect(() => {
    if(phoneAction == 'edit') {
      setPhoneNum(selectedPhone.phoneNum);
      setPhoneExt(selectedPhone.ext);
    } else {
      setPhoneNum('');
      setPhoneExt('');
    }
  }, [phoneAction]);

  const currentPhoneType = phoneTypes.find((x) => x.PhoneTypeID == selectedPhone.PhoneTypeID);

  const cleanPhoneNumber = (value) => {
    return value.replace(/\D/g, '');
  };

  return (
    <>
      {showFormStatuses.includes(phoneAction)
        && <form key={selectedPhone.phoneID}>
          <h3>{phoneAction === 'create' ? 'Add Phone' : 'Edit Phone'}</h3>
          <Input
            required
            label="Phone Number"
            value={phoneNum}
            onChange={(val) => setPhoneNum(cleanPhoneNumber(val))}
            error={invalidPhoneNumber}
            inverted
          />
          {currentPhoneType?.PhoneTypeID != 2 && (
            <Input
              label="Extension"
              value={phoneExt}
              onChange={(val) => setPhoneExt(cleanPhoneNumber(val))}
              inverted
            />
          )}
          <PhoneBookSelect
            label="Type"
            value={currentPhoneType?.PhoneTypeID.toString()}
            onChange={(value) => setSelectedPhone((prev) => Object.assign(
              {},
              prev,
              {
                PhoneTypeID: value,
              },
            ))}
            required
            noOptionsBorder
            inverted
            position={'top'}
          >
            {phoneTypes.filter((type) => !(phoneExt != '' && type.PhoneTypeID == 2)).map((type) => (
              <Item key={type.PhoneTypeID}>{type.PhoneType}</Item>
            ))}
          </PhoneBookSelect>
          <SubmitButton
            onPress={() => handleSubmit()}
          >
            Save Phone
          </SubmitButton>
          {' '}
          <CancelButton
            type="button"
            onPress={() => {
              setPhoneAction('');
              setSelectedPhone({ PhoneTypeID: 1, phoneID: 0, phoneNum: '', verifiedID: 0, ext: '' });
            }}
          >
            Cancel
          </CancelButton>
        </form>
      }
      <ConfirmFlexModal
        isOpen={reverifyConfirm}
        isDismissable
        showCloseButton
        title="Re-verification Required"
        onConfirm={() => {
          if(editPhoneData != []) {
            updatePhone(...editPhoneData);
          }
          setEditPhoneData([]);

          setReverifyConfirm(false);
        }}
        onReject={() => setReverifyConfirm(false)}
      >
        Editing this number will require it to be re-verified. Do you want to continue?
      </ConfirmFlexModal>
    </>);
};
